import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  FormControl,
  Validators,
  FormBuilder,
  FormGroup
} from '@angular/forms';
import { HttpModule, JsonpModule } from '@angular/http';
import { APP_BASE_HREF } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { MaterialModule } from './material.module';

// Custom Scrollbar
import {
  PerfectScrollbarModule,
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface
} from 'ngx-perfect-scrollbar';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  scrollXMarginOffset: 4,
  scrollYMarginOffset: 4
};

// App Routing Module
import { AppRoutingModule } from './app-routing.module';

// App Main Component
import { AppComponent } from './app.component';

import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LegalAgreementComponent } from './legal-agreement/legal-agreement.component';
import { MaintenanceModeComponent } from './maintenance-mode/maintenance-mode.component';
import { ProfileComponent } from './profile/profile.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ExpiredLinkComponent } from './expired-link/expired-link.component';

// Services, Guards, Schema, Environment and Responses

import {
  ProfilePictureService,
  TicketAttachmentService,
  RoleService,
  ApiService,
  AuthenticationService,
  LoadingService,
  MenuService,
  TicketService,
  TokenService,
  UserService,
  NotificationService,
  TemporaryUrlService,
  FrontPageGuard,
  APIResponse
} from './_shared';

import { Granule } from './config';
import { environment } from '../environments/environment';
import { NavbarRoutingModule } from './navbar/navbar-routing.module';
import { NavbarModule } from './navbar/navbar.module';

// Ticket Menu
import {
  AllTicketsComponent,
  MyTicketsComponent,
  TicketActionComponent,
  TicketDetailComponent,
  TicketListComponent,
  TicketMonitoringComponent,
  TicketItemComponent,
  TicketThreadComponent
} from './ticket';

// User Management Menu
import {
  AdministratorComponent,
  ClientComponent,
  UserLevelComponent
} from './user-management';

// Shared Component
import {
  FooterComponent,
  PrivacyComponentDialog,
  TermsComponentDialog,
  LoadingPageComponent,
  CustomSnackbarComponent
} from './_shared';
import { NotificationsComponent } from './notifications/notifications.component';
import { SearchResultComponent } from './search-result/search-result.component';

import { SharedLayoutModule } from './_shared/layout/shared-layout.module';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ForgotPasswordComponent,

    LegalAgreementComponent,
    MaintenanceModeComponent,
    LoadingPageComponent,
    FooterComponent,
    PrivacyComponentDialog,
    TermsComponentDialog,
    ResetPasswordComponent,
    ExpiredLinkComponent,
    CustomSnackbarComponent
  ],
  imports: [
    AppRoutingModule,
    NavbarModule,
    MaterialModule,
    BrowserModule,
    NgxPaginationModule,
    FormsModule,
    HttpModule,
    JsonpModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    PerfectScrollbarModule,
    SharedLayoutModule
  ],
  providers: [
    FrontPageGuard,
    ApiService,
    AuthenticationService,
    LoadingService,
    TicketService,
    TokenService,
    UserService,
    RoleService,
    NotificationService,
    TemporaryUrlService,
    ProfilePictureService,
    TicketAttachmentService,
    MenuService,
    Granule,
    APIResponse,
    Title
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    PrivacyComponentDialog,
    TermsComponentDialog,
    CustomSnackbarComponent
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/app.module.ts